import { render, staticRenderFns } from "./NeighbourhoodNavBtnMapCopy.vue?vue&type=template&id=a8592650&scoped=true&"
import script from "./NeighbourhoodNavBtnMapCopy.vue?vue&type=script&lang=js&"
export * from "./NeighbourhoodNavBtnMapCopy.vue?vue&type=script&lang=js&"
import style0 from "./NeighbourhoodNavBtnMapCopy.vue?vue&type=style&index=0&id=a8592650&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8592650",
  null
  
)

export default component.exports